import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'platform'})
export class PlatformNamePipe implements PipeTransform {
    public transform(value: any): string {
        let platforms = value.hasOwnProperty('length') ? value : [value];

        platforms.forEach((platform: string, index: number) => {
            let string = platform.replace('_', '.');

            platforms[index] = string[0].toUpperCase() + string.substr(1);
        });

        return platforms.join(', ');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/pipes/platform-name.pipe.ts